export default __webpack_public_path__ + "c6b1ebfe5926b03aa2b7ea56a3396864.png";